<template>
  <div class="home">
    <intro :content="homeContent.intro"/>
    <!-- Section Shopping List-->
    <first-section :content="homeContent.firstSection"/>
    <!-- Scanner Section -->
    <second-section :content="homeContent.secondSection"/>
  </div>
</template>

<script>

import Intro from '@/components/home/Intro.vue';
import FirstSection from '@/components/home/FirstSection.vue';
import SecondSection from '@/components/home/SecondSection.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: { SecondSection, FirstSection, Intro },
  created() {
    this.$store.dispatch('content/loadContentForView', 'home');
  },
  computed: {
    ...mapGetters({
      homeContent: 'content/getHomeContent',
    }),
  },
};
</script>
